<template>
  <CustomPage :noTitle="true">
    <template slot="content">
      <div id="home" style="background-color: #f7f7f7" ref="home">
        <HomepageHeader
          @activeTabChange="activeTabChange"
          ref="HomepageHeader"
          :act1="act1"
        />

        <component :is="component_c" />

        <!-- 首页下才有商品推荐和品牌会场的切换 -->
       <!-- <Tabs
          v-model="columnActive"
          class="columnTabs"
          v-if="activeTab === 'home'"
        >
          <Tab
            v-for="(item, index) in columnOptions"
            :key="item.value"
            :name="item.value"
          >
            <!~~ 动态切换激活商品推荐icon ~~>
            <template #title v-if="index === 0">
              <van-icon v-if="columnActive === 'good'" :name="item.activeImg" />
              <van-icon v-else :name="item.unActiveImg" />
              <span>{{ item.title }}</span>
            </template>
            <template #title v-else>
              <van-icon
                v-if="columnActive === 'brand'"
                :name="item.activeImg"
              />
              <van-icon v-else :name="item.unActiveImg" />
              <span>{{ item.title }}</span></template
            >
          </Tab>
        </Tabs>-->
        <!-- 现阶段不要品牌会场单写一个商品推荐 -->
        <div v-if="activeTab === 'home'" class="commodity px-2 flex items-center">
          <van-icon v-if="columnActive === 'good'" :name="columnOptions[0].activeImg" />
          <van-icon v-else :name="columnOptions[0].unActiveImg" />
          <span>{{ columnOptions[0].title }}</span>
        </div>

        <!-- 商品推荐-->

        <!-- <template>
          </template> -->
        <keep-alive>
          <GoodsRecommendTab
            v-show="activeTab === 'home' && columnActive === 'good'"
            :goodsSettingList="goodsSettingList"
            @lookMoreGoodsCate="lookMoreGoodsCate"
          />
        </keep-alive>
        <keep-alive>
          <!-- 品牌会场 -->
          <template v-if="activeTab === 'home' && columnActive === 'brand'">
            <BrandPlaceList
              v-if="['act1', 'act2'].indexOf(activeTab) === -1"
              :activeTab="activeTab"
              ref="BrandPlaceList"
              @setScrollTop="setScrollTop"
              :scrollTop="scrollTop"
            />
          </template>
        </keep-alive>

        <!-- 其他类目列表，比如童装等 -->

        <BrandPlaceList
          v-if="!['home', 'act1', 'act2'].includes(activeTab)"
          :activeTab="activeTab"
          ref="BrandPlaceList"
          @setScrollTop="setScrollTop"
          :scrollTop="scrollTop"
        />

        <CustomView />
        <Tabbar />
      </div>
      <Overlay
        v-if="redpackList.length"
        :show="$store.state.app.firstTime"
        @click="secondTime"
        :lock-scroll="false"
      >
        <div class="wrapper">
          <div class="block" style="position: relative" @click.stop>
            <div style="position: relative">
              <div
                style="
                  position: absolute;
                  color: #8b5d2b;
                  left: 50%;
                  top: 15%;
                  transform: translate(-50%);
                "
                class="flex items-baseline"
              >
                <div style="font-size: 20px">¥</div>
                <div
                  style="
                    font-size: 70px;
                    text-shadow: 1px 2px 0px rgba(255, 255, 255, 0.5);
                    font-family: PingFangSC-Semibold, PingFang SC;
                  "
                >
                  {{
                    redpackList.reduce(
                      (prev, cur) => prev + cur.faceValue || cur.reduceAmount,
                      0
                    )
                  }}
                </div>
              </div>
              <div
                style="
                  position: absolute;
                  color: #efe096;
                  left: 50%;
                  top: 54%;
                  transform: translate(-50%, -50%);
                "
                class="flex items-baseline"
              >
                <div style="font-size: 20px; text-shadow: 0px 2px 0px #af290d">
                  恭喜您获得
                </div>
              </div>
              <div
                style="
                  position: absolute;
                  left: 50%;
                  top: 73%;
                  transform: translate(-50%, -50%);
                "
                class="h-32 w-48 overflow-x-hidden overflow-y-scroll"
              >
                <div
                  v-for="item in redpackList"
                  :key="item.redPacketId"
                  class="flex mb-1 overflow-x-hidden overflow-y-auto"
                >
                  <div
                    :style="{
                      background:
                        'linear-gradient(90deg,#fb8787 0%,#e75050 100%)',
                    }"
                    class="
                      text-white
                      p-1
                      rounded-l-md
                      flex-shrink-0 flex-grow-0 flex flex-col
                      justify-center
                    "
                    style="width: 60px"
                  >
                    <div
                      class="flex font-semibold items-baseline justify-center"
                    >
                      <div class="text-xs">¥</div>
                      <div class="text-xl">
                        {{ item.faceValue || item.reduceAmount }}
                      </div>
                    </div>
                    <div
                      v-show="item.fullAmount"
                      class="text-xxs -mt-1 font-light text-center"
                    >
                      满{{ item.fullAmount }}元可用
                    </div>
                  </div>
                  <div class="bg-white p-1 rounded-r-md">
                    <div class="text-xs">
                      {{ item.redPacketName || item.title }}
                    </div>
                    <div class="text-xxs" style="color: #999999">
                      {{ item.startDate }} - {{ item.endDate }}
                    </div>
                  </div>
                </div>
              </div>
              <img src="@/assets/redpack/红包.png" alt />
            </div>
            <div
              style="position: absolute; right: 20px"
              class="top-0 text-white text-xs font-light"
              @click="secondTime(false)"
            >
              关闭
            </div>
            <div
              style="
                margin: 0 auto;
                text-align: center;

                width: 163px;
                height: 34px;
                background: linear-gradient(180deg, #ffe6b9 0%, #e59c3e 100%);
                box-shadow: 0px 3px 4px 0px rgba(110, 10, 10, 0.25);
                border-radius: 17px;
                font-size: 16px;
                font-family: PingFangSC-Medium, PingFang SC;
                font-weight: 600;
                color: #9d461c;
                line-height: 34px;
              "
              @click="secondTime(true)"
            >
              立即使用
            </div>
          </div>
        </div>
      </Overlay>
    </template>
  </CustomPage>
</template>

<script>
// @ is an alias to /src
import LotteryPlace from "@/views/LotteryPlace";
import DoubleCommission from "@/views/DoubleCommission";
import CustomView from "@/components/custom-view.vue";
import Tabbar from "@/components/Tabbar";
import HomepageHeader from "./homepageHeader";
import BrandPlaceList from "./brandPlaceList";
import CustomPage from "@/components/custom-page.vue";
import { Overlay, Tabs, Tab } from "vant";
import { getRedpackCenter, getRedpack, getStoreRedpack } from "./webApi";

import GoodsRecommendTab from "./goodsRecommendTab.vue";
import {
  getGoodsRecommendList,
  getGoodsRecommendImg,
} from "@/api/goodsRecommend";

export default {
  name: "Home",
  components: {
    Tabbar,
    HomepageHeader,
    BrandPlaceList,
    LotteryPlace,
    DoubleCommission,
    CustomPage,
    CustomView,
    Overlay,
    Tabs,
    Tab,
    GoodsRecommendTab,
  },

  data() {
    return {
      activeTab: "home",
      redpackList: [],
      wechat_info: {
        flag: false,
      },
      scrollTop: 0,
      act1: null,
      columnActive: "good", //切换是商品推荐还是品牌会场
      columnOptions: [
        {
          title: "商品推荐",
          value: "good",
          unActiveImg: require("@/assets/home/unactiveGoodsRecommendIcon.svg"),
          activeImg: require("@/assets/home/activeGoodsRecommendIcon.svg"),
        },
        // {
        //   title: "品牌会场",
        //   value: "brand",
        //   unActiveImg: require("@/assets/home/unactiveBrandPlaceIcon.svg"),
        //   activeImg: require("@/assets/home/activeBrandPlaceIcon.svg"),
        // },
      ],
      GoodsThemeList: [],
      GoodsThemeImg: "",
    };
  },
  created() {
    console.log("parent created");
    // 商品推荐主题列表，含商品详情
    getGoodsRecommendList()
      .then((res) => {
        console.log("getGoodsRecommendList", res);
        this.GoodsThemeList = res.data;
      })
      .catch((err) => {
        console.log(err);
      });

    // 商品推荐主图
    getGoodsRecommendImg()
      .then((res) => {
        console.log("getGoodsRecommendImg", res);
        this.GoodsThemeImg = res.data;
      })
      .catch((err) => {
        console.log(err);
      });

    if (this.$route.query.backRoute === "lottery") {
      this.activeTab = "act1";
      this.act1 = "act1";
    } else if (
      this.$route.query.backRoute !== "lottery" &&
      this.$store.state.app.firstTime
    ) {
      if (!this.$store.state.user.distributionFlag) {
        Promise.all([getRedpackCenter(), getStoreRedpack()]).then(
          ([res1, res2]) => {
            let list = res1.data.filter(
              (item) =>
                !item.isClaim &&
                item.remainNum > 0 &&
                this.dayjs(item.endDate).toDate() > new Date()
            );
            list.map((item) => {
              getRedpack(item.redPacketId);
            });
            this.redpackList = list.concat(res2.data);
          }
        );
      } else {
        getRedpackCenter().then(({ data }) => {
          this.redpackList = data.filter(
            (item) =>
              !item.isClaim &&
              item.remainNum > 0 &&
              this.dayjs(item.endDate).toDate() > new Date()
          );
          this.redpackList.map((item) => {
            getRedpack(item.redPacketId);
          });
        });
      }
    }

    // if (this.$store.state.app.firstTime) {
    //   if (!this.$store.state.user.distributionFlag) {
    //     Promise.all([getRedpackCenter(), getStoreRedpack()]).then(
    //       ([res1, res2]) => {
    //         let list = res1.data.filter(
    //           (item) =>
    //             !item.isClaim &&
    //             item.remainNum > 0 &&
    //             new Date(item.endDate) > new Date()
    //         )
    //         list.map((item) => {
    //           getRedpack(item.redPacketId)
    //         })
    //         this.redpackList = list.concat(res2.data)
    //       }
    //     )
    //   } else {
    //     getRedpackCenter().then(({ data }) => {
    //       this.redpackList = data.filter(
    //         (item) =>
    //           !item.isClaim &&
    //           item.remainNum > 0 &&
    //           new Date(item.endDate) > new Date()
    //       )
    //       this.redpackList.map((item) => {
    //         getRedpack(item.redPacketId)
    //       })
    //     })
    //   }
    // }
  },
  mounted() {
    this.getScrollTop();
  },
  computed: {
    component_c() {
      switch (this.activeTab) {
        case "act1":
          return "LotteryPlace";
        case "act2":
          return "DoubleCommission";
        default:
          return null;
      }
    },
    goodsSettingList() {
      const list = this.GoodsThemeList.map((item, index) => {
        item.mainImage = this.GoodsThemeImg;
        return item;
      });
      console.log("--------->list", list);
      return list;
    },
  },
  methods: {
    activeTabChange(val) {
      this.activeTab = val;
    },

    // 商品推荐查看更多
    lookMoreGoodsCate(val) {
      this.activeTab = val;
      if (val !== "act1" && val !== "act2") {
        this.$refs.HomepageHeader.activeCate = val;
        this.$refs.HomepageHeader.activeTab = val;
      }
    },
    secondTime(jump) {
      this.$store.dispatch("app/secondTime");
      if (jump) this.$router.push({ path: "mine/redpack" });
    },

    getScrollTop() {
      //获得滚动距离
      document.getElementById("home").addEventListener(
        "scroll",
        () => {
          this.scrollTop = document.getElementById("home").scrollTop;
          //body 加上静止屏幕拉动
          document.body.classList.add("modal-open");
          // console.log('我是打印的scrolltop', this.scrollTop)
        },
        true
      );
    },

    setScrollTop(scrollTop) {
      document.getElementById("home").scrollTop = scrollTop;
      //   this.$refs.BrandPlaceList.scrollTop = scrollTop
      //   console.log(this.$refs.BrandPlaceList, '自设滚动')

      // console.log(scrollTop, 'store中的')
    },
  },
};
</script>
<style lang="less" scoped>
#home {
  height: 100%;
  overflow-y: auto;

  // 修改商品和品牌栏目的tabs 样式
  /deep/ .columnTabs {
    .van-tabs__nav {
      background-color: unset;

      .van-tabs__line {
        width: unset;
      }

      &.van-tabs__nav--line {
        padding-bottom: 0;
        justify-content: center;
        .van-tab {
          color: #333333;
          font-size: 36px;
          font-weight: 400;
          flex: unset;

          .van-tab__text {
            display: flex;
            align-items: center;
            .van-icon {
              width: 35px;
              height: 35px;
              padding-right: 10px;
            }
          }

          &:nth-child(1) {
            padding-right: 18px;
          }
          &:nth-child(2) {
            padding-left: 18px;
          }
        }

        .van-tab--active {
          color: #e82035;
          font-weight: 600;
          font-family: PingFangSC-Semibold, PingFang SC;
        }
      }
    }
  }
}

// 控制商品推荐卡片展示的
::v-deep .van-grid-item__content {
  background-color: transparent;
  /* px-to-viewport-ignore-next */
  padding: 10px 5px;
  .goodsCard {
    width: fit-content;
    /* px-to-viewport-ignore-next */
    max-width: 172px;
  }
}

.wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
}
.commodity{
  .van-icon {
    width: 35px;
    height: 35px;
    padding-right: 10px;
  }
  span{
    color: #e82035;
    font-weight: 600;
    font-family: PingFangSC-Semibold, PingFang SC;
    font-size: 36px;
  }
}
</style>
